import {i18n} from '@/plugins/i18n'
import BankColumn from "../bank-column";

const bankTemplate = (row, index, datatable) => {
    let template = new BankColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}
export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'title',
        title: i18n.t('label.title'),
        sortable: false,
        textAlign: 'center'
    },
    {
        field: 'bank_name',
        title: i18n.t('label.bank'),
        sortable: false,
        width: 40,
        template: (row, index, datatable) => {
            return bankTemplate(row, index, datatable);
        },
        textAlign: 'center'
    },
    {
        field: 'account_number',
        title: i18n.t('label.account_number'),
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'sheba',
        title: i18n.t('label.sheba_number'),
        sortable: false,
        textAlign: 'center',
        width: 90
    },
]